export function getCurrentClientId(clientMasterId?: string | number | null) {
  const parsed = typeof clientMasterId === 'string'
    ? parseInt(clientMasterId, 10)
    : (clientMasterId ?? 0);

  return isNaN(parsed as number) ? 0 : (parsed as number);
}

export function buildDocLookup(documentsData: any[]) {
  const map: Record<number, any> = {};

  for (const doc of documentsData) {
    const parentId = doc.ParentClientMasterId;
    if (parentId != null && !(parentId in map)) {
      map[parentId] = doc;
    }
  }

  return map;
}

export function getSelectedK1Sources(documentsData: any[], selectedNodeIds: Set<string>) {
  return documentsData.filter(
    (doc) =>
      selectedNodeIds.has(String(doc.DocumentId)) &&
      doc.InternalK1SelectedReturnId &&
      doc.DocumentType === 'Internal Schedule K-1',
  );
}
